/* eslint-disable */


export default class Captcha {
  constructor(element, sitekey, form) {
    this.form = form;
    this.valid = true;
    this.element = element;
    this.sitekey = sitekey;
    this.captchaContainer = element.querySelector('[data-role="captcha-container"]');
    this.error = this.element.querySelector('[data-role="error"]');
    this.API = 'https://www.google.com/recaptcha/api.js';
    this.captcha = $('<div />', { class: 'g-recaptcha', 'data-size': "invisible", 'data-sitekey': this.sitekey, 'data-callback': 'captchaCallback'});
    this.init();
  }

  validate() {
    grecaptcha.execute();
    // const { requiredMessage } = this.element.dataset;
    // const validationResult = {
    //   valid: true,
    //   error: '',
    // };
    //
    // const captchaResponse = grecaptcha.getResponse($('.g-recaptcha').index(this.captcha));
    //
    // validationResult.valid = !!captchaResponse.length;
    // validationResult.error = validationResult.valid ? '' : requiredMessage;
    // this.valid = validationResult.valid;
    // $(this.element).toggleClass('is-invalid', !this.valid);
    // this.error.innerText = validationResult.error;
  }

  init() {
    window.captchaCallback = (token) => {
      $(this.element).find('.g-recaptcha-response').val(token);
      $(this.form).trigger('submitForm');
    }
    const script = document.createElement('script');
    $(document.body).append(script);
    script.onload = () => {
      $(this.captchaContainer).append(this.captcha);
    };
    script.src = this.API;
  }

  reset() {
    grecaptcha.reset($('.g-recaptcha').index(this.captcha));
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/form/components/Captcha/Captcha.js